import React, { Component, ReactNode } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { GetItemPropsOptions } from 'downshift';
import tinycolor from 'tinycolor2';

import { ComboboxItem, ToLabelFn, ToValueFn } from './types';

interface Props {
  children: ReactNode;
  item?: ComboboxItem;
  selectedItem?: ComboboxItem;
  index: number;
  highlightedIndex: number | null;
  /* eslint-disable no-unused-vars */
  getItemProps: (options: GetItemPropsOptions<any>) => any;
  toLabel: ToLabelFn;
  toValue: ToValueFn;
}

type StyleProps = {
  selected: boolean;
  highlighted: boolean;
  theme: any;
};

const StyledComboboxOption = styled('div')(
  ({ theme }: StyleProps) => css`
    label: base;
    padding: ${theme.space.sm} ${theme.space.md};
    font-size: ${theme.fontSizes.sm};
    margin: 0;
    color: ${theme.colors.heading};
    cursor: pointer;
  `,
  ({ selected, theme }: StyleProps) =>
    selected &&
    css`
      label: selected;
      background-color: ${tinycolor(theme.colors.blue).lighten(20).toHexString()};
    `,
  ({ highlighted, theme }: StyleProps) =>
    highlighted &&
    css`
      label: highlighted;
      background-color: ${tinycolor(theme.colors.blue).lighten(20).toHexString()};
      color: ${theme.colors.black};
    `
);
StyledComboboxOption.displayName = 'StyledComboboxOption';

export default class ComboboxOption extends Component<Props> {
  render() {
    const {
      children,
      item,
      selectedItem,
      index,
      highlightedIndex,
      getItemProps,
      toLabel,
      toValue,
    } = this.props;
    const highlighted = highlightedIndex != null && highlightedIndex === index;
    const selected = selectedItem != null && toValue(selectedItem) === toValue(item);
    return (
      <StyledComboboxOption
        {...getItemProps({ item })}
        highlighted={highlighted}
        selected={selected}
      >
        {children || toLabel(item)}
      </StyledComboboxOption>
    );
  }
}
